module.exports = __webpack_public_path__ + "static/status.f56e5b22.gif";